import controller from './returnsButton.controller';
import templateUrl from './returnsButton.html';

const returnsButtonComponent = {
  bindings: {
    onClick: '&',
    text: '<',
    type: '<',
    href: '<',
    tier: '@',
    loading: '<',
    big: '<',
    disableButton: '<',
    buttonLabel: '@',
  },
  transclude: true,
  templateUrl,
  controller,
};

export default returnsButtonComponent;
